import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { getTodos } from "@/tasks/services";
import { queryKeysTasks } from "@/tasks/config";

import type { GetTodosParams, GetTodosResponse } from "@/tasks/types";

export type UseTodosParams = GetTodosParams;

const FIVE_MINUTES = 5 * 60 * 1000;

const useTodos = ({
  completed,
  userId,
  limit = 10,
}: UseTodosParams): UseQueryResult<GetTodosResponse> => {
  const params = { completed, userId, limit };

  return useQuery<GetTodosResponse>({
    queryKey: queryKeysTasks.list(params),
    queryFn: async ({ signal }) => {
      return await getTodos(params, signal);
    },
    enabled: true,
    staleTime: FIVE_MINUTES,
  });
};

export { useTodos };
